import { createApi } from "@reduxjs/toolkit/query/react";
import authBaseQuery from "../../../../utils/authBaseQuery";

const HobbieApi = createApi({
  reducerPath: "HobbieApi",
  baseQuery: authBaseQuery,
  endpoints: (builder) => ({
    //Start Hobbies API's---------------------------------------
    getAllHobbieData: builder.query({
      query: () => "get_all_hobbies",
      transformResponse: (response) => response?.data || [],
    }),
    addHobbie: builder.mutation({
      query: (addHobbie) => ({
        url: "add_hobby",
        method: "POST",
        body: addHobbie,
      }),
    }),

    editHobbie: builder.mutation({
      query: (editHobbie) => ({
        url: `update_hobby`,
        method: "PUT",
        body: editHobbie,
      }),
    }),
    getHobbieById: builder.query({
      query: ({ id }) => `get_single_hobby/${id}`,
      transformResponse: (response) => response?.data || [],
    }),
    deleteHobbie: builder.mutation({
      query: (id) => ({
        url: `delete_hobby/${id}`,
        method: "DELETE",
      }),
    }),
    

    //END Hobbies API's---------------------------------------
  }),
});

export const {
  //Hobbie api
  useGetAllHobbieDataQuery,
  useAddHobbieMutation,
  useEditHobbieMutation,
  useGetHobbieByIdQuery,
  useDeleteHobbieMutation,
} = HobbieApi;

export default HobbieApi;
